import { createToastInterface } from "vue-toastification";

export default function (ctx, inject) {
  const toast = createToastInterface({"cssFile":"~\u002Fassets\u002Fscss\u002Fvue-toastification.scss"});
  inject('toast', toast);
}
